import { ContasReceberAnaliticoFilter } from './../../models/contas_receber_analitico_filter';
import { IGetContasReceberAnaliticoFiltrosUseCase } from "../../../presentation/useCases/read/get_contas_receber_analitico_filtros_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetContasReceberAnaliticoFiltrosUseCase
 */

export class GetContasReceberAnaliticoFiltrosUseCase implements IGetContasReceberAnaliticoFiltrosUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async execute(
  ): Promise<ContasReceberAnaliticoFilter | null> {
    return await this.repository.getContasReceberAnaliticoFiltros();

  }
}
